class DreamerArtistGlossary extends HTMLDivElement {
  constructor() {
    super();
    this.searchInput = this.querySelector('.artist-glossary__search-input');
    this.letterButtons = this.querySelectorAll('.artist-glossary__letter');
    this.listEl = this.querySelector('.artist-glossary__list');
    this.emptyState = this.querySelector('.artist-glossary__empty-state');
    // // this.resultsCount = this.querySelector('.artist-glossary__results-count');
    // this.paginationEl = this.querySelector('[data-artist-glossary-pagination]');
    // this.prevBtn = this.paginationEl ? this.paginationEl.querySelector('[data-artist-glossary-page="prev"]') : null;
    // this.nextBtn = this.paginationEl ? this.paginationEl.querySelector('[data-artist-glossary-page="next"]') : null;
    // this.paginationStatus = this.paginationEl ? this.paginationEl.querySelector('.artist-glossary__pagination-status') : null;

    this.itemTemplate = this.querySelector('template[data-artist-glossary-item-template]');
    this.pageJsonScript = this.querySelector('script[data-artist-glossary-page-json="true"]'); 

    this.currentFilter = 'all';
    this.searchTerm = '';
    this.logicalPage = 1;
    this.renderedCount = 0;

    this.allLoadedArtists = [];
    this.loadedUnderlyingPages = new Set();
    this.nextUnderlyingPageToFetch = 1;
    this.underlyingPagesTotal = 1;
    this.pageSize = 48;
    this.pageParam = 'page';
    this.underlyingFullyLoaded = false;

    this.paginationEl = null;
    this.nextBtn = null;
    this.infiniteScrollEnabled = false;
    this._loadingMore = false;
    this._requestId = 0;
  }

  connectedCallback() {
    console.log('DreamerArtistGlossary connectedCallback');
    if (!this.listEl || !this.pageJsonScript || !this.itemTemplate) return;

    this.pageSize = parseInt(this.pageJsonScript.dataset.pageSize || '48', 10);
    this.pageParam = this.pageJsonScript.dataset.pageParam || 'page';
    this.underlyingPagesTotal = parseInt(this.pageJsonScript.dataset.pages || '1', 10);

    // Initialize with the current underlying page already rendered by Liquid.
    let initialItems = [];
    try {
      initialItems = JSON.parse(this.pageJsonScript.textContent || '[]');
    } catch (err) {
      initialItems = [];
    }

    const initialUnderlyingPage = parseInt(this.pageJsonScript.dataset.currentPage || '1', 10);
    this.loadedUnderlyingPages.add(initialUnderlyingPage);
    this.allLoadedArtists = this.normalizeItems(initialItems);
    this.nextUnderlyingPageToFetch = initialUnderlyingPage + 1;

    this.setupSearch();
    this.setupAlphabetFilter();
    this.takeOverPagination();

    this.loadAndRender({ append: false });
  }

  takeOverPagination() {
    if (typeof this.listEl.destroy === 'function') {
      this.listEl.destroy();
    }

    this.paginationEl = this.listEl.querySelector('.js-pagination');
    this.nextBtn = this.paginationEl ? this.paginationEl.querySelector('.js-pagination__next-button') : null;
    this.infiniteScrollEnabled = this.listEl.dataset.infiniteScrollEnabled === 'true';

    if (this.nextBtn) {
      this._nextBtnOriginalText = this.nextBtn.textContent;
      this.nextBtn.addEventListener('click', (event) => {
        event.preventDefault();
        this.loadMore();
      });
    }

    if (this.infiniteScrollEnabled && this.paginationEl) {
      this.intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.loadMore();
            clearInterval(this.nextButtonTimer);
            this.nextButtonTimer = setInterval(() => this.loadMore(), 1500);
          } else {
            clearInterval(this.nextButtonTimer);
          }
        });
      }, { rootMargin: `${window.innerHeight}px 0px` });
    }
  }

  setNextButtonLoading(loading) {
    if (!this.nextBtn) return;
    if (loading) {
      this.nextBtn.setAttribute('aria-disabled', 'true');
      this.nextBtn.textContent = window.strings?.general?.pagination?.loadingText || this._nextBtnOriginalText;
    } else {
      this.nextBtn.removeAttribute('aria-disabled');
      if (this._nextBtnOriginalText != null) {
        this.nextBtn.textContent = this._nextBtnOriginalText;
      }
    }
  }

  updatePaginationVisibility(hasMore) {
    if (!this.paginationEl) return;

    this.paginationEl.hidden = !hasMore;

    if (!this.intersectionObserver) return;

    if (hasMore && !this._loadingMore) {
      this.intersectionObserver.observe(this.paginationEl);
    } else if (!hasMore) {
      this.intersectionObserver.unobserve(this.paginationEl);
      clearInterval(this.nextButtonTimer);
    }
  }

  async loadMore() {
    if (this._loadingMore) return;
    if (!this.paginationEl || this.paginationEl.hidden) return;

    this._loadingMore = true;
    this.logicalPage += 1;
    await this.loadAndRender({ append: true });
  }

  setupSearch() {
    if (!this.searchInput) return;

    const self = this;
    let debounceTimer;
    
    this.searchInput.addEventListener('input', function(e) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() {
        self.searchTerm = e.target.value.toLowerCase().trim();
        self.logicalPage = 1;
        self.loadAndRender();
      }, 150);
    });
  }

  setupAlphabetFilter() {
    console.log('setupAlphabetFilter');
    const self = this;
    this.letterButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        console.log('button clicked', this);
        const letter = this.getAttribute('data-letter');
        
        self.letterButtons.forEach(function(btn) {
          btn.classList.remove('button--primary');
          btn.classList.add('button--secondary');
        });
        this.classList.remove('button--secondary');
        this.classList.add('button--primary');
        
        self.currentFilter = letter;
        self.logicalPage = 1;
        self.loadAndRender({ append: false });
      });
    });
  }

  currentFilteredItems() {
    const term = this.searchTerm;
    const letter = this.currentFilter;

    return this.allLoadedArtists.filter((item) => {
      const nameLower = (item.nameLower || item.name || '').toLowerCase();
      const matchesSearch = term === '' || nameLower.includes(term);
      const matchesLetter = letter === 'all' || item.letter === letter;
      return matchesSearch && matchesLetter;
    });
  }

  async ensureFilteredCountAtLeast(targetCount, requestId) {
    // The filtered set depends on search + letter. We keep fetching until either:
    // 1) we have enough filtered items, or 2) we've fetched all underlying pages.
    while (!this.underlyingFullyLoaded) {
      if (this._requestId !== requestId) return;
      const filtered = this.currentFilteredItems();
      if (filtered.length >= targetCount) return;

      const nextPage = this.nextUnderlyingPageToFetch;
      if (nextPage > this.underlyingPagesTotal) {
        this.underlyingFullyLoaded = true;
        return;
      }

      await this.fetchUnderlyingPage(nextPage);
      this.nextUnderlyingPageToFetch = nextPage + 1;
    }
  }

  async fetchUnderlyingPage(underlyingPageNumber) {
    if (this.loadedUnderlyingPages.has(underlyingPageNumber)) return;

    // Prevent overlapping loads from racing.
    const requestId = this._requestId;

    const url = new URL(window.location.href);
    url.searchParams.set(this.pageParam, underlyingPageNumber);

    let responseText = '';
    try {
      const res = await fetch(url.toString(), { credentials: 'same-origin' });
      responseText = await res.text();
    } catch (e) {
      return;
    }

    if (this._requestId !== requestId) return;

    const doc = new DOMParser().parseFromString(responseText, 'text/html');
    const script = doc.querySelector('script[data-artist-glossary-page-json="true"]');
    if (!script) return;

    let items = [];
    try {
      items = JSON.parse(script.textContent || '[]');
    } catch (err) {
      items = [];
    }

    this.allLoadedArtists = this.allLoadedArtists.concat(this.normalizeItems(items));
    this.loadedUnderlyingPages.add(underlyingPageNumber);
  }

  normalizeItems(items) {
    return (Array.isArray(items) ? items : []).map((item) => {
      const name = item.name || '';
      return {
        ...item,
        nameLower: String(name).toLowerCase()
      };
    });
  }

  fillItem(node, item) {
    const name = item.name || '';
    const nameLower = item.nameLower || name.toLowerCase();
    const id = item.id != null && item.id !== '' ? String(item.id) : nameLower.replace(/[^a-z0-9]+/g, '-');
    const modalId = `ArtistModal-${id}`;
    const collectionUrl = item.url || '';
    const deferredTemplate = node.querySelector('template.deferred');
    const roots = deferredTemplate ? [node, deferredTemplate.content] : [node];

    const queryAll = (selector) => roots.flatMap((root) => Array.from(root.querySelectorAll(selector)));
    const query = (selector) => {
      for (const root of roots) {
        const el = root.querySelector(selector);
        if (el) return el;
      }
      return null;
    };

    node.dataset.artistName = nameLower;
    node.dataset.letter = item.letter || '';

    queryAll('[data-artist-glossary-name-text]').forEach((el) => {
      el.textContent = name;
    });

    const trigger = query('[data-artist-glossary-trigger]');
    if (trigger) {
      const labelTemplate = this.dataset.viewArtistLabel || 'View __NAME__';
      trigger.setAttribute('aria-label', labelTemplate.replace(/__NAME__/g, name));
    }

    const opener = query('[data-artist-glossary-modal-opener]');
    if (opener) opener.setAttribute('data-modal', `#${modalId}`);

    const modal = query('[data-artist-glossary-modal]');
    if (modal) modal.id = modalId;

    const dialog = query('[data-artist-glossary-dialog]');
    if (dialog) dialog.setAttribute('aria-label', name);

    const closeBtn = query('[data-artist-glossary-modal-close]');
    if (closeBtn) closeBtn.id = `ModalClose-${id}`;

    const photoEl = query('[data-artist-glossary-photo]');
    const photoMedia = query('[data-artist-glossary-photo-media]');
    if (item.photoHtml && photoEl && photoMedia) {
      photoMedia.innerHTML = item.photoHtml;
      photoEl.hidden = false;
    }

    const modalPhoto = query('[data-artist-glossary-modal-photo]');
    const modalPhotoMedia = query('[data-artist-glossary-modal-photo-media]');
    if (item.photoModalHtml && modalPhoto && modalPhotoMedia) {
      modalPhotoMedia.innerHTML = item.photoModalHtml;
      modalPhoto.hidden = false;
    }

    const bio = query('[data-artist-glossary-bio]');
    if (item.bioHtml && bio) {
      bio.innerHTML = item.bioHtml;
      bio.hidden = false;
    }

    queryAll('[data-artist-glossary-collection-link]').forEach((link) => {
      if (collectionUrl) {
        link.href = collectionUrl;
        link.hidden = false;
      }
    });
  }

  setButtonDisabled(button, disabled) {
    if (!button) return;
    button.disabled = disabled;
    button.classList.toggle('disabled', disabled);
  }

  render(options = {}) {
    if (!this.listEl || !this.itemTemplate) return;

    const append = Boolean(options.append);
    const filtered = this.currentFilteredItems();
    const endIndex = this.logicalPage * this.pageSize;
    const startIndex = append ? this.renderedCount : 0;
    const pageItems = filtered.slice(startIndex, endIndex);

    if (!append) {
      this.listEl.querySelectorAll('.artist-glossary__item').forEach((el) => el.remove());
      this.renderedCount = 0;
      if (this.intersectionObserver && this.paginationEl) {
        this.intersectionObserver.unobserve(this.paginationEl);
      }
      clearInterval(this.nextButtonTimer);
    }

    if (filtered.length === 0) {
      if (this.emptyState) this.emptyState.hidden = false;
    } else if (this.emptyState) {
      this.emptyState.hidden = true;
    }

    const fragment = document.createDocumentFragment();
    pageItems.forEach((item) => {
      const node = this.itemTemplate.content.firstElementChild.cloneNode(true);
      this.fillItem(node, item);
      fragment.appendChild(node);
    });

    this.renderedCount += pageItems.length;

    if (this.paginationEl) {
      this.listEl.insertBefore(fragment, this.paginationEl);
    } else {
      this.listEl.appendChild(fragment);
    }

    this.updatePaginationVisibility(filtered.length > this.renderedCount);

    // Results count is based on *all loaded* matching items (not just the current page).
    // if (this.resultsCount) {
    //   const count = filtered.length;
    //   if (this.searchTerm || this.currentFilter !== 'all') {
    //     this.resultsCount.textContent = count + ' artist' + (count !== 1 ? 's' : '') + ' found';
    //   } else {
    //     this.resultsCount.textContent = count + ' total artist' + (count !== 1 ? 's' : '');
    //   }
    //   this.resultsCount.style.display = 'block';
    // }

    // if (this.paginationStatus) {
    //   const pageLabel = this.logicalPage;
    //   this.paginationStatus.textContent = 'Page ' + pageLabel;
    // }

    // Update prev/next availability.
    // this.setButtonDisabled(this.prevBtn, this.logicalPage <= 1);
    // const hasNext = filtered.length > endIndex;
    // this.setButtonDisabled(this.nextBtn, !hasNext);
  }

  async loadAndRender(options = {}) {
    const append = Boolean(options.append);
    this._requestId++;
    const requestId = this._requestId;
    this._loadingMore = true;
    this.setNextButtonLoading(true);

    try {
      const endIndex = this.logicalPage * this.pageSize;
      const targetForNext = endIndex + 1;

      await this.ensureFilteredCountAtLeast(targetForNext, requestId);
      if (this._requestId !== requestId) return;

      const filteredNow = this.currentFilteredItems();
      const maxLogicalPage = Math.max(1, Math.ceil(filteredNow.length / this.pageSize) || 1);
      this.logicalPage = Math.min(this.logicalPage, maxLogicalPage);

      this.render({ append });
    } finally {
      if (this._requestId === requestId) {
        this._loadingMore = false;
        this.setNextButtonLoading(false);
        this.updatePaginationVisibility(this.currentFilteredItems().length > this.renderedCount);
      }
    }
  }
}
customElements.define('artist-glossary', DreamerArtistGlossary, { extends: "div" });
